






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ICourse, IProgram, SearchType } from '../Scripts/ISearchService';

type FieldData<T> = {
	name: string;
	field: (p: T) => string;
};

@Component({
	components: {
	}
})
export default class FavoritesSlider extends Vue {
	@Prop() public programs!: IProgram[];
	@Prop() public version!: number;
	@Prop() public searchType!: SearchType;

	get count (): number {
		return this.$store.state.favoritesCount;
	}

	get fields (): FieldData<IProgram>[] | FieldData<ICourse>[] {
		switch (this.searchType) {
			case SearchType.Program: return this.programFields;
			case SearchType.Course: return this.courseFields;
			default: return [];
		}
	}

	get programFields (): FieldData<IProgram>[] {
		return [
			{ name: 'Institution', field: (p: IProgram | ICourse) => p.institutionName },
			{ name: 'Location', field: (p: IProgram) => `${p.city}, ${p.state}` },
			{ name: 'Program Level', field: (p: IProgram) => p.level },
			{ name: 'Degree Type', field: (p: IProgram) => p.degree },
			{ name: 'Subject', field: (p: IProgram) => p.subject },
			{ name: 'Instructional Language', field: (p: IProgram) => p.language },
			{ name: 'Speed', field: (p: IProgram) => p.deliverySpeed },
			{ name: 'Method', field: (p: IProgram) => p.deliveryMode },
			{ name: 'Presence Requirement', field: (p: IProgram) => p.presence || 'None' },
			{ name: 'Length', field: (p: IProgram) => p.length },
			{ name: 'Average Time', field: (p: IProgram) => p.averageTime },
			{ name: 'In-State Tutition and Fees', field: (p: IProgram) => `$${p.inState.toLocaleString()}` },
			{ name: 'Out-of-State Tutition and Fees', field: (p: IProgram) => `$${p.outState.toLocaleString()}` },
			{ name: 'Other Costs', field: (p: IProgram) => p.costs || 'None' },
			{ name: 'Description', field: (p: IProgram) => p.description }
		];
	}

	get courseFields (): FieldData<ICourse>[] {
		return [
			{ name: 'Institution', field: (p: ICourse) => p.institutionName },
			{ name: 'Location', field: (p: ICourse) => `${p.city}, ${p.state}` },
			{ name: 'Term', field: (p: ICourse) => { return p.yearTerm + (p.termDisplay ? ` (${p.termDisplay})` : ''); } },
			{ name: 'Course Identifier', field: (p: ICourse) => `${p.courseDepartment} ${p.courseNumber}` },
			{ name: 'Credits', field: (p: ICourse) => `${p.credits.toFixed(2)} (${p.unitForCredits})` },
			{ name: 'Course Level', field: (p: ICourse) => p.courseLevel },
			{ name: 'Subject', field: (p: ICourse) => p.subject },
			{ name: 'Prerequisites', field: (p: ICourse) => p.prerequisites },
			{ name: 'Instructional Language', field: (p: ICourse) => p.language },
			{ name: 'Speed', field: (p: ICourse) => p.deliverySpeed },
			{ name: 'Method', field: (p: ICourse) => p.deliveryMode },
			{ name: 'Presence Requirement', field: (p: ICourse) => p.presence || 'None' },
			{ name: 'In-State Tutition and Fees', field: (p: ICourse) => `$${p.inState.toLocaleString()}` },
			{ name: 'Out-of-State Tutition and Fees', field: (p: ICourse) => `$${p.outState.toLocaleString()}` },
			{ name: 'Other Costs', field: (p: ICourse) => p.costs || 'None' },
			{ name: 'Additional Information', field: (p: ICourse) => p.additionalInformation || 'N/A' },
			{ name: 'Description', field: (p: ICourse) => p.description }
		];
	}
}
